import { IonButton, IonIcon, IonItem, IonLabel, IonSpinner, IonText } from '@ionic/react';
import { refresh } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { syncTimer } from '../../../common/interval';
import { IWorkCategorySyncStatus } from '../../../models/dms/technician.model';
import { useDataSync } from '../../../providers/DataSyncProvider';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { setWorkCategoriesHasSyncStoreAsync, setWorkCategoriesSyncLoadingState } from '../../../store/workCategorySyncSlice';

interface IComponentProps {
  title: string;
}

let workCategoriesTime: { timestamp: number; sync?: IWorkCategorySyncStatus } = {
  timestamp: 0,
  sync: undefined,
};

const WorkCategoriesSyncItem: React.FC<IComponentProps> = ({ title }) => {
  const { enableOfflineMode } = useAppSelector((state) => state.settings);
  const {
    state: { workCategoriesSyncTimer },
  } = useDataSync();

  const dispatch = useAppDispatch();

  const [delayCodeTimestamp, setDelayCodeTimestamp] = useState(0);
  const { workCategoriesSync, workCategoriesSyncLoading } = useAppSelector((state) => state.workCategorySync);

  useEffect(() => {
    const syncSub = syncTimer.subject.subscribe((id) => {
      if (id > 0) {
        const now = new Date().getTime();

        // Repair orders
        if (workCategoriesTime.sync) {
          if (workCategoriesTime.sync.timestamp <= 0) {
            workCategoriesTime.timestamp = -1;
          } else {
            const timeDiff = now - workCategoriesTime.sync.timestamp;
            workCategoriesTime.timestamp = Math.floor(timeDiff / 60000);
            setDelayCodeTimestamp(workCategoriesTime.timestamp);
          }
        }
      }
    });

    return () => syncSub.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    workCategoriesTime.sync = workCategoriesSync;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workCategoriesSync]);

  const handleRefreshButtonClick = () => {
    dispatch(setWorkCategoriesSyncLoadingState(true));
    dispatch(setWorkCategoriesHasSyncStoreAsync(false));
    workCategoriesSyncTimer?.fire();
  };

  return (
    <IonItem>
      <IonLabel text-wrap>
        <IonText>
          <IonLabel>{title}</IonLabel>
        </IonText>
        {(() => {
          switch (workCategoriesSyncLoading) {
            case false:
              return (
                <IonText color="medium">
                  Last sync - <span>{delayCodeTimestamp} minutes</span>
                </IonText>
              );
            case true:
              return <IonText>Last sync - synchronising...</IonText>;
          }
        })()}
      </IonLabel>
      {enableOfflineMode && (
        <IonButton slot="end" color="primary" disabled={workCategoriesSyncLoading} onClick={() => handleRefreshButtonClick()}>
          {(() => {
            switch (workCategoriesSyncLoading) {
              case false:
                return <IonIcon icon={refresh} color="secondary" />;
              case true:
                return <IonSpinner name="lines-small" color="secondary"></IonSpinner>;
            }
          })()}
        </IonButton>
      )}
    </IonItem>
  );
};

export default WorkCategoriesSyncItem;
